/**
 * values for setting the 'consent' in opt in
 */
import { locale } from './../../ModuleEditor/util/locale-wrapper';

const OPT_IN_CONSENT = {
  OPT_IN:  'opt_in',
  OPT_OUT: 'opt_out',
};

const OPT_IN_CONSENT_ALL = _.values(OPT_IN_CONSENT);

const OPT_IN_CONSENT_LIST = [
  { text: locale('Opt In'), value: OPT_IN_CONSENT.OPT_IN, description: '' },
  { text: locale('Opt Out'), value: OPT_IN_CONSENT.OPT_OUT, description: '' },
];

export { OPT_IN_CONSENT, OPT_IN_CONSENT_LIST, OPT_IN_CONSENT_ALL };

export default OPT_IN_CONSENT;
